<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-toolbar>
  <ion-searchbar
    mode="ios"
    placeholder="Search"
    (keyup.enter)="filterListOnEnter($event)"
    (ionInput)="filterLIst($event)"
  >
  </ion-searchbar>
</ion-toolbar>

<ion-content>
  <ion-grid *ngIf="noData; else showList" class="ion-text-center v-center">
    <ion-row>
      <ion-col size="12">
        <ion-label class="fs-3 font500 black-text-color">Search</ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-template #showList>
    <div *ngIf="suggestionList.length > 0">
      <ion-list class="ion-padding-end ion-list-transparent-bg-color">
        <ion-item
          *ngFor="
            let item of suggestionList;
            &quot;ion-item-transparent-bg-color&quot;
          "
          (click)="selectSuggestion(item)"
        >
          <ng-template [ngIf]="item.type === 'TBOCITY'">
            <ion-icon
              slot="end"
              name="business-outline"
              class="primary-icon-color"
            ></ion-icon>
            <ion-label>
              <p class="fs-3 font500 airport_name paragraph-primary-text-color">
                {{ item.title }} , {{ item.country }}
              </p>
            </ion-label>
          </ng-template>
          <ng-template [ngIf]="item.type === 'HOTEL'">
            <ion-icon
              slot="end"
              name="bed-outline"
              class="primary-icon-color"
            ></ion-icon>
            <ion-label>
              <p class="fs-3 font500 airport_name paragraph-primary-text-color">
                {{ item.title }}
              </p>
              <p class="fs-3 font400 paragraph-secondary-text-color">
                {{ item.city }} , {{ item.country }}
              </p>
            </ion-label>
          </ng-template>
        </ion-item>
      </ion-list>
      <ion-infinite-scroll
        [disabled]="lastPage"
        (ionInfinite)="getNextPage($event)"
      >
        <ion-infinite-scroll-content loadingSpinner="crescent">
        </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>

    <div *ngIf="suggestionList.length <= 0 && loading">
      <ion-list>
        <ion-item *ngFor="let item of [0, 1, 2, 3, 4, 5, 6, 7]">
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 80%; height: 16px">
              </ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 50%">
              </ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </ng-template>
</ion-content>
